import { DataRole, DataType, } from '@mode-switch/express';
import { Model } from '@mode-switch/model';
import { Catalog } from '../Catalog';
export class GenericCatalog {
    getParam(model, path) {
        return Model.Params.find(model, path.name);
    }
    getViewAttr(model, viewName, path) {
        if (path.view == null) {
            return Model.Views.findAttr(model, viewName, path.name);
        }
        else {
            const view = Model.Views.find(model, path.view);
            if (view == null) {
                return undefined;
            }
            else {
                return Model.Views.findAttr(model, view.name, path.name);
            }
        }
    }
    getExprCall(exprEnv, callName, callArgs, type, role) {
        return Catalog.getExprCall(exprEnv, callName, callArgs, type, role);
    }
    getCallArgs(model, viewName, callName, callArgs) {
        return Catalog.getCallArgs(model, viewName, callName, callArgs);
    }
    isSupportedCallName(callName) {
        return Catalog.isSupportedCallName(callName);
    }
    validateExprCall(callNode, callName, callArgs, type, role) {
        return Catalog.validateExprCall(callNode, callName, callArgs);
    }
    getExprCallType(callName, callArgs, argTypes) {
        const type = Catalog.getExprCallType(callName, callArgs, argTypes);
        if (type == null) {
            throw new Error(`Cannot determine type of function call ${callName.name}`);
        }
        return type;
    }
    getExprCallRole(callName, callArgs, argRoles) {
        return Catalog.getExprCallRole(callName, callArgs, argRoles);
    }
    getNegatedType(type) {
        switch (type.name) {
            case "FLOAT":
            case "DECIMAL":
            case "INTEGER":
                return type;
            default:
                throw new Error(`Cannot determine type of -${type.name}`);
        }
    }
    getPlussedType(type) {
        switch (type.name) {
            case "FLOAT":
            case "DECIMAL":
            case "INTEGER":
                return type;
            default:
                throw new Error(`Cannot determine type of +${type.name}`);
        }
    }
    getAddedType(left, right) {
        switch (left.name) {
            case "FLOAT": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                        return left;
                    case "DECIMAL":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} + ${right.name}`);
                }
            }
            case "INTEGER": {
                switch (right.name) {
                    case "FLOAT":
                    case "DECIMAL":
                    case "INTEGER":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} + ${right.name}`);
                }
            }
            case "DECIMAL": {
                switch (right.name) {
                    case "FLOAT":
                    case "DECIMAL":
                    case "INTEGER":
                        return left;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} + ${right.name}`);
                }
            }
            default:
                throw new Error(`Cannot determine type of ${left.name} + ${right.name}`);
        }
    }
    getDividedType(left, right) {
        switch (left.name) {
            case "FLOAT": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                        return left;
                    case "DECIMAL":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} / ${right.name}`);
                }
            }
            case "INTEGER": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                        return DataType.FloatType.make();
                    case "DECIMAL":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} / ${right.name}`);
                }
            }
            case "DECIMAL": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                    case "DECIMAL":
                        return left;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} / ${right.name}`);
                }
            }
            default:
                throw new Error(`Cannot determine type of ${left.name} / ${right.name}`);
        }
    }
    getMathedType(left, right, operator) {
        switch (left.name) {
            case "FLOAT": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                        return left;
                    case "DECIMAL":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} ${operator} ${right.name}`);
                }
            }
            case "INTEGER": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                    case "DECIMAL":
                        return right;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} ${operator} ${right.name}`);
                }
            }
            case "DECIMAL": {
                switch (right.name) {
                    case "FLOAT":
                    case "INTEGER":
                    case "DECIMAL":
                        return left;
                    default:
                        throw new Error(`Cannot determine type of ${left.name} ${operator} ${right.name}`);
                }
            }
        }
        throw new Error(`Cannot determine type of ${left.name} ${operator} ${right.name}`);
    }
    getLiteralType(node) {
        return Catalog.getLiteralType(node);
    }
    validateRelationalType(left, right, operator) {
        return Catalog.validateRelationalType(left, right, operator);
    }
    roleEquals(left, right) {
        return DataRole.equals(left, right);
    }
    getNegatedRole(role) {
        return role;
    }
    getPlussedRole(role) {
        return role;
    }
    getAddedRole(left, right) {
        if ((left && left.name) === (right && right.name)) {
            return left;
        }
        else {
            return undefined;
        }
    }
    getMathedRole(left, right) {
        if ((left && left.name) === (right && right.name)) {
            return left;
        }
        else {
            return undefined;
        }
    }
}
